import {Box, Slot as BaseSlot} from '@logistics-frontend/blocks'
import type {ReactElement} from 'react'

import {renderWidget} from '../index'
import type {SlotWidgetConfig} from '../types'
import * as styles from './Slot.classes'
import {SlotBody} from './SlotBody'

/**
 * Компонент слота.
 * Слот - бокс с текстовыми мини-блоками в середине и любыми компонентами в начале/конце блока.
 */
export const Slot = ({slot}: SlotWidgetConfig): ReactElement => {
  const {lead, body1, body2, body3, trail1, trail2} = slot

  return (
    <BaseSlot>
      <Box alignItems="center" className={styles.box} gap="m" justifyContent="space-between">
        {lead && renderWidget(lead)}
        {body1 && <SlotBody body={body1} />}
        {body2 && <SlotBody body={body2} />}
        {body3 && <SlotBody body={body3} />}
        {trail1 && renderWidget(trail1)}
        {trail2 && renderWidget(trail2)}
      </Box>
    </BaseSlot>
  )
}
